"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminInstructorEmailsController = /** @class */ (function () {
    function AdminInstructorEmailsController(instructor, APPURL, PostOfficeModel) {
        var _this = this;
        this.instructor = instructor;
        this.APPURL = APPURL;
        //@TODO investigate this; should probably be notifications
        PostOfficeModel.getSenders(this.instructor.email)
            .then(function (response) {
            _this.emails = response.data;
        })
            .catch(function (Error) {
            console.error(Error);
        });
    }
    return AdminInstructorEmailsController;
}());
AdminInstructorEmailsController.$inject = [
    "instructor",
    "APPURL",
    "PostOfficeModel",
];
exports.default = AdminInstructorEmailsController;
